import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AboutPage from "@/pages/AboutPage";
import WelcomePage from "@/pages/WelcomePage";
import TablePage from "@/pages/TablePage";
import RestorePage from "@/pages/RestorePage";
import PartnersPage from "@/pages/PartnersPage";
import SeasonsPage from "@/pages/SeasonsPage";
import SnowPage from "@/pages/SnowPage";
import JournalPage from "@/pages/JournalPage";
import BookPage from "@/pages/BookPage";
import MembershipPage from "@/pages/MembershipPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/table" element={<TablePage />} />
          <Route path="/restore" element={<RestorePage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/seasons" element={<SeasonsPage />} />
          <Route path="/snow" element={<SnowPage />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/admin" element={<Admin />} />
          {/* Legacy redirects */}
          <Route path="/services" element={<Navigate to="/welcome" replace />} />
          <Route path="/ethos" element={<Navigate to="/about" replace />} />
          <Route path="/gallery" element={<Navigate to="/about" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121110",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#F4F0EA",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
